import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import { GeorgiaDfcsBenefits } from "@minicity/core";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShelterOrUtilityExpenseEditor',
  props: {
    modelValue: null,
    prompt: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue?: Partial<GeorgiaDfcsBenefits.ShelterOrUtilityExpense>|null,
    prompt: string,
}



const enabled = ref<boolean|null>(null);
const expense = ref<Partial<GeorgiaDfcsBenefits.ShelterOrUtilityExpense>>({payerName: ""});

// Event for two-way binding


const onInput = () => {
  if (enabled.value === true) {
    if (!expense.value.amount || !expense.value.frequency || expense.value.payerName!.length == 0) {
      // Validation error
      emit('update:modelValue', undefined);
    } else {
      emit('update:modelValue', {...expense.value});
    }
  } else if (enabled.value === false) {
    emit('update:modelValue', null);
  } else {
    emit('update:modelValue', undefined);
  }
};

onMounted(() => {
  if (props.modelValue === undefined) {
    // Nothing
  } else if (props.modelValue === null) {
    // No expense
    enabled.value = false;
  } else {
    // Expense
    enabled.value = true;
    expense.value = {...props.modelValue};
  }
})

return (_ctx: any,_cache: any) => {
  const _component_FormRadioGroupField = _resolveComponent("FormRadioGroupField")!
  const _component_FormTextField = _resolveComponent("FormTextField")!
  const _component_HalfColumn = _resolveComponent("HalfColumn")!
  const _component_FormSelectField = _resolveComponent("FormSelectField")!
  const _component_Columns = _resolveComponent("Columns")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormRadioGroupField, {
      label: __props.prompt,
      options: {'Yes': true, 'No': false},
      modelValue: enabled.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((enabled).value = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (onInput()))
    }, null, 8, ["label", "modelValue"]),
    (enabled.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_HalfColumn, null, {
            default: _withCtx(() => [
              _createVNode(_component_FormTextField, {
                label: "Who pays? *",
                modelValue: expense.value.payerName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((expense.value.payerName) = $event)),
                trimmed: "",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (onInput()))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Columns, null, {
            default: _withCtx(() => [
              _createVNode(_component_FormTextField, {
                label: "How much ($)? *",
                modelValue: expense.value.amount,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((expense.value.amount) = $event)),
                numeric: "",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (onInput()))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_FormSelectField, {
                label: "Payment frequency *",
                options: _unref(GeorgiaDfcsBenefits).PaymentFrequency,
                modelValue: expense.value.frequency,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((expense.value.frequency) = $event)),
                  _cache[7] || (_cache[7] = ($event: any) => (onInput()))
                ]
              }, null, 8, ["options", "modelValue"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})